var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 39.16c-4.68-1.8-8-6.35-8-11.66 0-6.05 4.3-11.1 10.01-12.25-.01-.08-.01-.17-.01-.25 0-7.73 6.27-14 14-14 5.67 0 10.55 3.37 12.75 8.22 1.23-.77 2.69-1.22 4.25-1.22 4.25 0 7.72 3.31 7.98 7.49 5.21 1.51 9.02 6.32 9.02 12.01 0 5.31-3.32 9.86-8 11.66z",
    fill: "#4b84dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9 38v-14c0-1.657 1.343-3 3-3h10.757c.796 0 1.559.316 2.121.879l1.243 1.243c.563.563 1.326.879 2.121.879h19.757c1.657 0 3 1.343 3 3v8l-42 3z",
    fill: "#69adfe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13 37v-8c0-.552.448-1 1-1h32c.552 0 1 .448 1 1v8z",
    fill: "#e8ecef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m51 56v-21c0-1.657-1.343-3-3-3h-10.757c-.796 0-1.559.316-2.121.879l-1.243 1.243c-.563.563-1.326.879-2.121.879h-19.758c-1.657 0-3 1.343-3 3v18c0 1.657 1.343 3 3 3h36c1.657 0 3-1.343 3-3z",
    fill: "#8dd1fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFolder);
export default __webpack_public_path__ + "static/media/cloud-folder.abfe08f44735fc9279ddbb49a733e8a1.svg";
export { ForwardRef as ReactComponent };